import * as Dialog from "@radix-ui/react-dialog";
import { BackDrop } from "@volumental/common";
import type React from "react";
import type { JSX } from "react";
import { cn } from "../../lib/cn";

export interface PopupProps {
  show: boolean;
  fixAspect?: boolean;
  close?: () => void;
  children: React.ReactNode;
}

export function Popup({ show, fixAspect = false, close, children }: PopupProps): JSX.Element {
  return (
    <Dialog.Root open={show} onOpenChange={(open) => !open && close?.()}>
      <Dialog.Portal>
        <div className={cn("fixed inset-0 z-2", show ? "animate-sidebar-fade-in" : "animate-sidebar-fade-out")}>
          <BackDrop visible={show} animationTime="0.3s" onClick={close} />
          <Dialog.Content
            onEscapeKeyDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
              close?.();
            }}
            className={cn(
              "fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center justify-center bg-white rounded-3xl max-h-[calc(100%-34px)] pt-6 outline-none z-3 overflow-hidden animate-sidebar-fade-in",
              fixAspect ? "aspect-square w-4/5 max-w-75" : "w-9/10 max-w-9/10"
            )}
          >
            {children}
          </Dialog.Content>
        </div>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
